import React from "react";
import ThemeProvider from "@pency/components/structure/ThemeProvider";

import {Tenant} from "./types";
import {getTheme} from "./selectors";

interface Context {
  state: {
    tenant: Tenant;
  };
}

interface Props {
  initialValue: Tenant;
}

const TenantContext = React.createContext({} as Context);

const TenantProvider: React.FC<Props> = ({children, initialValue: tenant}) => {
  const state: Context["state"] = {tenant};
  const customTheme = React.useMemo(() => getTheme(tenant.color), [tenant.color]);

  return (
    <ThemeProvider theme={customTheme}>
      <TenantContext.Provider value={{state}}>{children}</TenantContext.Provider>
    </ThemeProvider>
  );
};

export {TenantProvider as Provider, TenantContext as default};
